import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { PlanActionType } from '../actions/actionTypes';
import { setCreatePlanError, setPlanById, setPlans } from '../actions/action';
import { setButtonLoading, setError, setModal, setProcessLoading, setSuccess } from '../../../../../store/action';
import { planService } from '../../../services/plans';

function* callCreatePlan({ payload: { values, history } }) {
    yield put(setButtonLoading(true));
    const response = yield call(planService.createPlan, values);

    if (response.isRight()) {
        yield put(setButtonLoading(false));
        yield put(setModal({ createPlanModal: false }));
        history.push('/plans/' + response.value.getValue().id);
    } else {
        yield put(setCreatePlanError(response.value));
        yield put(setButtonLoading(false));
    }
}

function* callGetPlans({ payload: values }) {
    yield put(setProcessLoading(true));

    const response = yield call(planService.getPlans, values);

    if (response.isRight()) {
        yield put(setPlans(response.value.getValue()));
        yield put(setProcessLoading(false));
    } else {
        yield put(setProcessLoading(false));
    }
}

function* callGetPlanById({ payload: planId }) {
    const response = yield call(planService.getPlanById, planId);

    if (response.isRight()) {
        yield put(setProcessLoading(false));
        yield put(setPlanById(response.value.getValue()));
    } else {
        yield put(setError(response.value));
        yield put(setProcessLoading(false));
    }
}
function* callUpdatePlan({ payload: { values, planId } }) {
    yield put(setButtonLoading(true));
    yield put(setCreatePlanError(''));
    const response = yield call(planService.updatePlan, { planId, values });

    if (response.isRight()) {
        yield put(setPlanById(response.value.getValue()));
        yield put(setModal({ editPlanModal: false }));
        yield put(setButtonLoading(false));
    } else {
        yield put(setCreatePlanError(response.value));
        yield put(setButtonLoading(false));
    }
}
function* callDeletePlan({ payload: { planId, history } }) {
    const response = yield call(planService.deletePlan, planId);

    if (response.isRight()) {
        yield put(setProcessLoading(false));
        yield put(setSuccess('Plan Successfully Deleted!!!'));
        yield put(setModal({ deletePlanModal: false }));
        history.push('/plans');
    } else {
        yield put(setProcessLoading(false));
    }
}
export function* watchCallDeletePlan() {
    yield takeEvery<any>(PlanActionType.DELETE_PLAN, callDeletePlan);
}
export function* watchCallUpdatePlan() {
    yield takeEvery<any>(PlanActionType.UPDATE_PLAN, callUpdatePlan);
}
export function* watchCallGetPlans() {
    yield takeEvery<any>(PlanActionType.GET_PLANS, callGetPlans);
}
export function* watchCallCreatePlan() {
    yield takeEvery<any>(PlanActionType.CREATE_PLAN, callCreatePlan);
}
export function* watchCallGetPlanById() {
    yield takeEvery<any>(PlanActionType.GET_PLAN_BY_ID, callGetPlanById);
}

function* PlansSaga() {
    yield all([
        fork(watchCallCreatePlan),
        fork(watchCallGetPlans),
        fork(watchCallGetPlanById),
        fork(watchCallUpdatePlan),
        fork(watchCallDeletePlan)
    ]);
}
export default PlansSaga;
